"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var category_model_1 = require("./model/category/category.model");
var of_1 = require("rxjs/observable/of");
/**
 * @author Gor.Hakobyan on 03-May-18.
 */
var HttpClassifierDataService = /** @class */ (function () {
    function HttpClassifierDataService() {
    }
    /**
     * return indicator context types array
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getIndicatorContextTypes = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_context_type_quantitative"),
            new category_model_1.Category(2, null, "ui_me.indicator_context_type_qualitative")
        ]);
    };
    /**
     * return indicator types array
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getIndicatorTypes = function () {
        return of_1.of([
            new category_model_1.Category(3, null, "ui_me.indicator_type_impact"),
            new category_model_1.Category(1, null, "ui_me.indicator_type_outcome"),
            new category_model_1.Category(2, null, "ui_me.indicator_type_output")
        ]);
    };
    /**
     * return natures array
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getNatures = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_nature_incremental"),
            new category_model_1.Category(2, null, "ui_me.indicator_nature_cumulative")
        ]);
    };
    /**
     * return Data Formats array
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getDataFormats = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_data_format_number"),
            new category_model_1.Category(2, null, "ui_me.indicator_data_format_text"),
            new category_model_1.Category(3, null, "ui_me.indicator_data_format_value_list"),
            new category_model_1.Category(5, null, "ui_me.indicator_data_format_percent"),
            new category_model_1.Category(4, null, "ui_me.indicator_data_format_date")
        ]);
    };
    /**
     * return number Of Decimal Places
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getNumberOfDecimalPlaces = function () {
        return of_1.of([
            new category_model_1.Category(0, null, "ui_me.indicator_number_of_decimal_place_0"),
            new category_model_1.Category(1, null, "ui_me.indicator_number_of_decimal_place_1"),
            new category_model_1.Category(2, null, "ui_me.indicator_number_of_decimal_place_2"),
            new category_model_1.Category(3, null, "ui_me.indicator_number_of_decimal_place_3"),
            new category_model_1.Category(4, null, "ui_me.indicator_number_of_decimal_place_4")
        ]);
    };
    /**
     * return aggregation Functions array for combo box by current language ID
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getAggregationFunctions = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_aggregation_function_avg"),
            new category_model_1.Category(2, null, "ui_me.indicator_aggregation_function_first"),
            new category_model_1.Category(3, null, "ui_me.indicator_aggregation_function_last"),
            new category_model_1.Category(4, null, "ui_me.indicator_aggregation_function_max"),
            new category_model_1.Category(5, null, "ui_me.indicator_aggregation_function_min")
        ]);
    };
    /**
     * return all frequencies array for combo box by current language ID
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getFrequencies = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_frequency_once"),
            new category_model_1.Category(2, null, "ui_me.indicator_frequency_annual"),
            new category_model_1.Category(3, null, "ui_me.indicator_frequency_semi_annual"),
            new category_model_1.Category(4, null, "ui_me.indicator_frequency_quarter"),
            new category_model_1.Category(5, null, "ui_me.indicator_frequency_month"),
            new category_model_1.Category(6, null, "ui_me.indicator_frequency_week"),
            new category_model_1.Category(7, null, "ui_me.indicator_frequency_day")
        ]);
    };
    /**
     * get disaggregation show on table combo items by current language ID
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getDisaggregationShowOnTableItems = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_disaggregation_show_on_table_item_row"),
            new category_model_1.Category(2, null, "ui_me.indicator_disaggregation_show_on_table_item_column")
        ]);
    };
    /**
     * get disaggregation filter combo items by current language ID
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getDisaggregationFilterItems = function () {
        //TODO
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_disaggregation_none"),
            new category_model_1.Category(2, null, "ui_me.indicator_disaggregation_filter_item_select"),
            new category_model_1.Category(3, null, "ui_me.indicator_disaggregation_filter_item_multiple_select")
        ]);
    };
    /**
     * get data point types combo items
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getDataPointTypes = function () {
        return of_1.of([
            new category_model_1.Category(101, null, "ui_me.indicator_data_point_type_baseline"),
            new category_model_1.Category(102, null, "ui_me.indicator_data_point_type_target"),
            new category_model_1.Category(103, null, "ui_me.indicator_data_point_type_actual"),
            new category_model_1.Category(104, null, "ui_me.indicator_data_point_type_none")
        ]);
    };
    /**
     * get data point data formats
     * @returns {Observable<Array<Category>>}
     */
    HttpClassifierDataService.prototype.getDataPointDataFormats = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_data_point_data_format_number"),
            new category_model_1.Category(2, null, "ui_me.indicator_data_point_data_format_text"),
            new category_model_1.Category(3, null, "ui_me.indicator_data_point_data_format_value_list"),
            new category_model_1.Category(4, null, "ui_me.indicator_data_point_data_format_date"),
            new category_model_1.Category(5, null, "ui_me.indicator_data_point_data_format_percent"),
            new category_model_1.Category(6, null, "ui_me.indicator_data_point_data_format_comment"),
            new category_model_1.Category(7, null, "ui_me.indicator_data_point_data_format_expression")
        ]);
    };
    HttpClassifierDataService.prototype.getFrameworkTypes = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.framework_type_corporate"),
            new category_model_1.Category(2, null, "ui_me.framework_type_activity_specific")
        ]);
    };
    HttpClassifierDataService.prototype.getIndicatorStatuses = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.indicator_statuses_active"),
            new category_model_1.Category(2, null, "ui_me.indicator_statuses_suspended"),
            new category_model_1.Category(3, null, "ui_me.indicator_statuses_closed")
        ]);
    };
    HttpClassifierDataService.prototype.getChangeDirections = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.change_directions_increasing"),
            new category_model_1.Category(2, null, "ui_me.indicator_statuses_decreasing")
        ]);
    };
    HttpClassifierDataService.prototype.getWBSCodes = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.do_not_show_WBS_numbering"),
            new category_model_1.Category(2, null, "ui_me.show_WBS_numbering_as_separate_column_and_in_the_statement"),
            new category_model_1.Category(3, null, "ui_me.show_WBS_numbering_only_with_statement"),
            new category_model_1.Category(4, null, "ui_me.show_WBS_numbering_only_as_a_separate_column")
        ]);
    };
    HttpClassifierDataService.prototype.getSequences = function () {
        return of_1.of([
            new category_model_1.Category(1, null, "ui_me.sequence_number"),
            new category_model_1.Category(2, null, "ui_me.sequence_character_lowercase"),
            new category_model_1.Category(3, null, "ui_me.sequence_character_uppercase"),
            new category_model_1.Category(4, null, "ui_me.sequence_roman_number")
        ]);
    };
    HttpClassifierDataService.prototype.getSeparators = function () {
        return of_1.of([
            new category_model_1.Category(1, '.', null),
            new category_model_1.Category(2, '+', null),
            new category_model_1.Category(3, '/', null)
        ]);
    };
    HttpClassifierDataService = __decorate([
        core_1.Injectable()
    ], HttpClassifierDataService);
    return HttpClassifierDataService;
}());
exports.HttpClassifierDataService = HttpClassifierDataService;
//# sourceMappingURL=http-classifier-data.service.js.map